import { render, staticRenderFns } from "./ValidateEmail.vue?vue&type=template&id=7080c4b6&"
import script from "./ValidateEmail.vue?vue&type=script&lang=js&"
export * from "./ValidateEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports